<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920997735115289981536598669.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920999806801019723926491527.jpg",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914255085828694739648201311.png",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicCourse.vue